export const areStringArraysEqual = (left: readonly string[], right: readonly string[]) =>
  left.length === right.length && left.every((value, index) => value === right[index]);

export const stringArrayMemoizeOptions = {
  memoizeOptions: { resultEqualityCheck: areStringArraysEqual },
};

/** Own-key shallow equality for flat records with primitive values. */
export const areShallowRecordsEqual = (
  left: Record<string, unknown>,
  right: Record<string, unknown>,
) => {
  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);
  return (
    leftKeys.length === rightKeys.length &&
    leftKeys.every((key) => Object.hasOwn(right, key) && left[key] === right[key])
  );
};

export const shallowRecordMemoizeOptions = {
  memoizeOptions: { resultEqualityCheck: areShallowRecordsEqual },
};
